/**
 * Property type filter chips for Real Estate workspace UI.
 */
export const PROPERTY_TYPE_FILTERS = [
  'All',
  'Apartment Complex',
  'Villa',
  'Commercial',
  'Residential',
  'Mixed Use',
];
